// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__B-mio","header":"ReportDetails_header__kQWb6","title":"ReportDetails_title__gY9R0","left":"ReportDetails_left__1TbgU"};